import { createGtm } from '@gtm-support/vue-gtm'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(createGtm(
    {
      id: 'GTM-TDJR3RN',
      loadScript: true,
      enabled: true,
      debug: true
    }
  ))
})
